























































































































































































import { namespace } from 'vuex-class';
import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
// components
import draggable from 'vuedraggable';
// interfaces
import { CourseElementVm, CustomTranslationType } from '@/interfaces/CourseElementVm';
import { CourseElementTypeItem, courseElementTypeItems } from "@/interfaces/Types";
import { CourseElementType } from '@/interfaces/CourseElementType';
import { ExType } from '@/interfaces/ExType';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CcPageVm } from '@/interfaces/CcPageVm';
import { CustomizationVm } from '@/interfaces/CustomizationVm';
import { ExBundleVM } from '@/interfaces/ExBundleAssignmentGroupVM';

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
    components: {
      draggable
    }
  })
  export default class ElementPalette extends Vue {
    @Prop() resolutionSelected!: boolean;

    @customization.Getter customizationSettings!: CustomizationVm;
    @globals.Getter selectedBundle!: ExBundleVM;
    @globals.Getter selectedExercise!: ExerciseVM;
    @globals.Getter selectedModulePage!: CcPageVm | null;
    @globals.Getter isMasterLanguageCode!: boolean;
    courseElementTypeItems = courseElementTypeItems;

    // @Watch("selectedExercise")
    // async onSelectedExerciseChange() {
    // }

    get textElements(): CourseElementTypeItem[] {
      return this.courseElements.filter(x =>
        x.value == CourseElementType.Text ||
        x.value == CourseElementType.MdText ||
        x.value == CourseElementType.SequentialList ||
        x.value == CourseElementType.FlipCardList ||
        x.value == CourseElementType.Pdf
      );
    }

    get audioElements(): CourseElementTypeItem[] {
      return this.courseElements.filter(x =>
        x.value == CourseElementType.Audio ||
        x.value == CourseElementType.TtsSpeak ||
        x.value == CourseElementType.TtsAudio ||
        x.value == CourseElementType.AudioPodcast
      );
    }

    get imageElements(): CourseElementTypeItem[] {
      return this.courseElements.filter(x =>
        x.value == CourseElementType.Image ||
        x.value == CourseElementType.HeroHeadline
      );
    }

    get videoElements(): CourseElementTypeItem[] {
      return this.courseElements.filter(x =>
        x.value == CourseElementType.Video
      );
    }

    get questionElements(): CourseElementTypeItem[] {
      return this.courseElements.filter(x =>
        x.value == CourseElementType.SingleChoice ||
        x.value == CourseElementType.MultipleChoice ||
        x.value == CourseElementType.Slider ||
        x.value == CourseElementType.Rating ||
        x.value == CourseElementType.Comment
      );
    }

    get courseElements(): CourseElementTypeItem[] {
      if (!this.selectedModulePage || !this.isMasterLanguageCode) return [];

      // Handle manual and module approval
      if (this.selectedExercise?.type == ExType[ExType.ManualApproval] || this.selectedExercise?.type == ExType[ExType.ModuleApproval])
        return <CourseElementTypeItem[]>[];

      // Handle Signature
      if (this.selectedExercise?.type == ExType[ExType.Signature] && (this.selectedModulePage.courseElements?.length ?? 0 > 0))
        return <CourseElementTypeItem[]>[];
      if (this.selectedExercise?.type == ExType[ExType.Signature])
        return courseElementTypeItems.filter(x => x.value == CourseElementType.Signature);

      // Handle Scorm
      if (this.selectedExercise?.type == ExType[ExType.Scorm] && (this.selectedModulePage.courseElements?.length ?? 0 > 0))
        return <CourseElementTypeItem[]>[];
      if (this.selectedExercise?.type == ExType[ExType.Scorm])
        return courseElementTypeItems.filter(x => x.value == CourseElementType.Scorm);

      // Handle auto-generated tests
      if (this.selectedExercise.type == 'Test' && this.selectedExercise.autoGenerateTest)
        return [];

      // Filter out Signature and Scorm elements, because they are already handled above
      let elements = courseElementTypeItems.filter(x =>
        x.value != CourseElementType.Signature &&
        x.value != CourseElementType.Scorm
      );

      // Filter out AI elements
      if (!this.customizationSettings.enableAi) {
        elements = elements.filter(x =>
          x.value != CourseElementType.TtsAudio &&
          x.value != CourseElementType.AudioPodcast
        );
      }

      // Filter out Survey elements
      if (this.selectedExercise?.type != ExType[ExType.Survey]) {
        elements = elements.filter(x =>
          x.value != CourseElementType.Slider &&
          x.value != CourseElementType.Rating &&
          x.value != CourseElementType.Comment
        );
      }

      // Filter out selection elements if resolution is selected
      if (this.resolutionSelected) {
        elements = elements.filter(x =>
          x.value != CourseElementType.SingleChoice &&
          x.value != CourseElementType.MultipleChoice
        );
      }

      // Filter out single and multiple choice for Rules if sequential module processing is not enabled
      // if (!this.selectedBundle?.sequentialModuleProcessing && (this.selectedExercise?.type == "Rule" || this.selectedExercise?.type == "Explanation")) {
      if (!this.selectedBundle?.sequentialModuleProcessing && this.selectedExercise?.type == "Rule") {
        elements = elements.filter(x =>
          x.value != CourseElementType.SingleChoice &&
          x.value != CourseElementType.MultipleChoice
        );
      }

      // Filter out elements that are already in the course
      if (this.selectedModulePage.courseElements?.find(x =>
        x.type == CourseElementType[CourseElementType.SingleChoice] ||
        x.type == CourseElementType[CourseElementType.MultipleChoice] ||
        x.type == CourseElementType[CourseElementType.Slider] ||
        x.type == CourseElementType[CourseElementType.Rating] ||
        x.type == CourseElementType[CourseElementType.Comment]
        )) {
          elements = elements.filter(x =>
            x.value != CourseElementType.SingleChoice &&
            x.value != CourseElementType.MultipleChoice &&
            x.value != CourseElementType.Slider &&
            x.value != CourseElementType.Rating &&
            x.value != CourseElementType.Comment
          );
        }

        return elements;
    }

    private cloneElement(elementTypeItem: CourseElementTypeItem): CourseElementVm {
      // console.log('cloneElement', CourseElementType[elementTypeItem.value]);
      let text = "";
      if (elementTypeItem.value == CourseElementType.Signature) {
        text = "Bestätigen Sie bitte mit Ihrer Unterschrift, dass Sie diese Schulung besucht haben."
      }

      let max = 5;
      switch (elementTypeItem.value) {
        case CourseElementType.Rating:
          text = "Wie bewerten Sie diese Schulung?";
          break;
        case CourseElementType.Slider:
          text = "Bitte bewerten Sie die Schulung auf einer Skala von 1 bis 5.";
          max = 5;
          break;
        case CourseElementType.Signature:
          text = "Bitte unterschreiben Sie hier.";
          break;
        case CourseElementType.Comment:
          max = 500;
      }

      return <CourseElementVm>{
        id: Date.now(), // will be overwritten as soon as it is dropped in the course
        guid: this.$globalHelper.getNewGuid(),
        type: CourseElementType[elementTypeItem.value],
        textCustomTranslation: CustomTranslationType.Master,
        contentUrlCustomTranslation: CustomTranslationType.Master,
        // aiSummaryCustomTranslation: CustomTranslationType.Master,
        altTextCustomTranslation: CustomTranslationType.Master,
        titleCustomTranslation: CustomTranslationType.Master,
        leftLabelCustomTranslation: CustomTranslationType.Master,
        rightLabelCustomTranslation: CustomTranslationType.Master,
        text: text,
        imageLibrarySearchText: '',
        changePrompt: '',
        contentUrl: '',
        invisible: false,
        file: '',
        aiSummary: '',
        width: '',
        height: elementTypeItem.value === CourseElementType.HeroHeadline ? '200' : '',
        alignment: elementTypeItem.value === CourseElementType.Image ? 'center' : '',
        textAlign: elementTypeItem.value === CourseElementType.HeroHeadline ? 'left' : '',
        transparentGradient: elementTypeItem.value === CourseElementType.HeroHeadline ? true : false,
        darkMode: elementTypeItem.value === CourseElementType.HeroHeadline ? 'auto' : '',
        color: '',
        size: '',
        weight: '',
        fontStyle: '',
        title: '',
        aspectRatio: elementTypeItem.value === CourseElementType.Image ? '16:9' : '',
        fillContainer: elementTypeItem.value === CourseElementType.HeroHeadline ? true : false,
        imagePosition: elementTypeItem.value === CourseElementType.Image ? 'center' : '',
        createdWithAi: false,
        altText: '',
        style: elementTypeItem.value === CourseElementType.Image ? 'Photo realistic' : '',
        enableZoom: false,
        enableScore: false,
        closed: elementTypeItem.value === CourseElementType.Pdf ? true : false,
        enableDownload: false,
        enablePrint: false,
        hideText: false,
        dense: false,
        pitch: 1.0,
        rate: 1.0,
        preventSeeking: false,
        playOnLoad: false,
        min: 1,
        max: max,
        preset: 5,
        leftLabel: elementTypeItem.value === CourseElementType.Slider ? 'Stimme überhaupt nicht zu' : '',
        rightLabel: elementTypeItem.value === CourseElementType.Slider ? 'Stimme voll und ganz zu' : '',
        showAnswer: false,
        showCorrectAnswer: false,
        showManuelApprovalComment: elementTypeItem.value === CourseElementType.Signature ? true : false,
        options: elementTypeItem.value === CourseElementType.MultipleChoice || elementTypeItem.value === CourseElementType.SingleChoice ? [
          { id: 1, guid: this.$globalHelper.getNewGuid(), customTranslation: CustomTranslationType.Master, title: '', text: '', resolution: '', isRight: false, contentUrl: '', fillContainer: false, horizontalAlign: 'end', prompt: '', changePrompt: '', altText: '', imageLibrarySearchText: '' },
          { id: 2, guid: this.$globalHelper.getNewGuid(), customTranslation: CustomTranslationType.Master, title: '', text: '', resolution: '', isRight: false, contentUrl: '', fillContainer: false, horizontalAlign: 'end', prompt: '', changePrompt: '', altText: '', imageLibrarySearchText: '' }
        ] : [],
        compSettings: null,
        children: []
      };
    }
  }
